/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';

export const container = css({
  minHeight: '56px',
  padding: '12px 16px',
  maxHeight: 'inherit !important',
});

export const phoneNumberFieldCssProps1 = {
  input: css({}),
};

export const customContainerCss = css({
  paddingTop: '12px',
  minHeight: '56px',
  border: '#d7d7d7 solid 1px',
});

export const enquiryInput1 = css({
  marginBottom: '16px',

  label: {
    color: '#888888',
  },
});

export const enquiryInput = css({
  marginBottom: 16,
});

export const phoneNumberFieldCssProps = {
  container: css({
    minHeight: '56px',
    padding: '12px 16px',
    borderRadius: '4px',
    border: '#d7d7d7 solid 1px',
  }),
};

export const phoneNumberField = css({
  fontSize: '15px',
  label: {
    color: '#888888',
  },
});
export const enquirySubmit = css({
  marginTop: 32,
  background: '#E52500',
  borderRadius: '8px',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  height: '56px',
  color: '#fff',
  textDecoration: 'none',
  textTransform: 'uppercase',
  fontSize: '14px',
  lineHeight: '18px',
  letterSpacing: '0.875px',
  cursor: 'pointer',
  textAlign: 'center',
  border: '0',

  ':hover': {
    background: '#d42705',
    outlineColor: '#d42705',
  },

  [MediaQueries.md]: { maxWidth: '186px' },
  [MediaQueries.lg]: { maxWidth: '186px' },
});

export const msgBox = css({ padding: '15px 0px 0px', display: 'none' });
export const success = css({ color: colorsPalette.teal });
export const error = css({ color: colorsPalette.red });
